export const BACKEND_URL = "https://app.api.duneassurances.com";
export const REACT_QUERY_DEVTOOLS = false;
export const ENV: "dev" | "staging" | "production" = "production";
export const DEFAULT_EMAIL_DOMAIN = "app.mg.duneassurances.com";
